import React from 'react';
import { Container, Typography, Box, Divider } from "@mui/material";
import { LEGAL_DOCUMENTS } from "../constants/legalDocuments";

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box sx={{ background: 'var(--bg-card)', p: 4, borderRadius: 3, border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-sm)' }}>
        <Typography variant="h4" fontWeight="800" gutterBottom>
          {LEGAL_DOCUMENTS.privacy.title}
        </Typography>
        
        <Divider sx={{ my: 3 }} />

        <Box sx={{ 
            color: 'var(--text-secondary)', 
            fontFamily: 'Inter',
            whiteSpace: 'pre-wrap',
            '& h1': { fontSize: '1.5rem', color: 'var(--text-primary)', mb: 2 },
            '& h2': { fontSize: '1.2rem', color: 'var(--accent-blue)', mt: 3, mb: 1 },
            '& p': { lineHeight: 1.6, mb: 2 },
            '& ul': { mb: 2, paddingLeft: 3 }
        }}>
          <div dangerouslySetInnerHTML={{ __html: LEGAL_DOCUMENTS.privacy.content.replace(/\n\n/g, '<br/><br/>').replace(/^# (.*$)/gim, '<h1>$1</h1>').replace(/^## (.*$)/gim, '<h2>$1</h2>').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
        </Box>
      </Box>
    </Container>
  );
}
